import { z } from 'zod';

export const managementSummaryReportFormatSchema = z.enum(['xlsx', 'pdf']);

export const managementSummaryParametersSchema = z
	.object({
		startDate: z.iso.date(),
		endDate: z.iso.date(),
		facilityId: z.string(),
		format: managementSummaryReportFormatSchema.default('xlsx'),
	})
	.superRefine((value, ctx) => {
		if (value.endDate < value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'End date must be on or after start date',
			});
		}
	});

export type ManagementSummaryParameters = z.infer<typeof managementSummaryParametersSchema>;
export type ManagementSummaryReportFormat = z.infer<typeof managementSummaryReportFormatSchema>;
